
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.945 11.443c-5.055-3.791-9.864-3.686-9.864-3.686l-.491.562c5.967 1.825 8.74 4.458 8.74 4.458-8.338-4.57-18.133-4.57-26.221-1.018a37.164 37.164 0 00-2.071 1.018s2.913-2.773 9.232-4.599l-.351-.421s-4.81-.105-9.864 3.686c0 0-5.055 9.162-5.055 20.465 0 0 2.949 5.09 10.706 5.336 0 0 1.3-1.58 2.352-2.914-4.458-1.334-6.143-4.142-6.143-4.142.517.361 1.368.83 1.44.877 5.924 3.319 14.34 4.406 21.904 1.23a20.094 20.094 0 004.036-2.072s-1.755 2.879-6.353 4.177a151.716 151.716 0 002.317 2.844C40.016 36.998 43 31.908 43 31.908c0-11.303-5.055-20.465-5.055-20.465zm-22.01 17.2c-1.965 0-3.58-1.755-3.58-3.896s1.58-3.896 3.58-3.896c2.002 0 3.616 1.755 3.581 3.896 0 2.141-1.58 3.896-3.58 3.896zm12.813 0c-1.965 0-3.58-1.755-3.58-3.896s1.58-3.896 3.58-3.896c2.001 0 3.58 1.755 3.58 3.896s-1.579 3.896-3.58 3.896z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    